/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/cloud-exercise/v1.ts
 */

import { createValidator } from '../../helpers/validator';
export const CloudExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    blueprintFileName: {
      type: 'string',
      title: 'Blueprint name',
      description: 'The name of the blueprint to use for creation a session.'
    },
    cloudProvider: {
      type: 'string',
      enum: ['azure', 'aws', 'snowflake'],
      title: 'Cloud provider',
      description: 'The cloud provider to use for creating a session.'
    },
    fallbackAsset: {
      anyOf: [{
        type: 'object',
        properties: {
          assetType: {
            type: 'string',
            enum: ['Image', 'Video'],
            title: 'Asset type',
            description: 'The type of visual asset for this exercise'
          },
          assetUrl: {
            type: 'string',
            title: 'Asset Url',
            description: 'The url to the visual asset for this exercise',
            pattern: '^https://(learn-api|videos|assets)\\.datacamp(-staging)?\\.com/.*'
          }
        },
        required: ['assetType', 'assetUrl'],
        title: 'Asset'
      }, {
        type: 'null',
        title: 'Empty'
      }],
      title: 'Fallback Asset',
      description: 'The fallback asset to use on mobile devices.',
      default: {
        assetType: 'Image',
        assetUrl: 'https://assets.datacamp.com/example.png'
      }
    },
    forceNewSession: {
      type: 'boolean',
      default: false,
      title: 'Force new session',
      description: 'Should the exercise create a new session, even if one already exists?'
    },
    instructionSteps: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          hint: {
            type: 'string',
            description: 'The hint text for this step.'
          },
          instructions: {
            type: 'string',
            description: 'The instructions text for this step.'
          }
        },
        required: ['hint', 'instructions']
      },
      title: 'Instruction steps',
      description: 'Incremental instruction steps. These can not be empty.'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['Open'],
            default: 'Open'
          },
          openQuestions: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                question: {
                  type: 'string',
                  description: 'Question asked to the user.'
                },
                solution: {
                  type: 'object',
                  properties: {
                    answer: {
                      type: 'string',
                      description: 'Correct answer to the question.'
                    },
                    message: {
                      type: 'string',
                      description: 'Feedback message when the submission matches the pattern.'
                    },
                    pattern: {
                      type: 'string',
                      description: 'Regex that should validate the correctness of the submission.'
                    }
                  },
                  required: ['answer', 'message', 'pattern']
                },
                feedback: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      message: {
                        type: 'string',
                        description: 'Feedback message when the submission matches the pattern.'
                      },
                      pattern: {
                        type: 'string',
                        description: 'If the regex matches, the feedback message will be shown. The last pattern should be ".*" to show a default error message.'
                      }
                    },
                    required: ['message', 'pattern']
                  },
                  description: 'List of feedback displayed when the submission is incorrect.'
                }
              },
              required: ['question', 'solution', 'feedback']
            },
            description: 'List of open questions.'
          }
        },
        required: ['flavor', 'openQuestions'],
        title: 'Open'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleChoiceInSteps'],
            default: 'PureMultipleChoiceInSteps'
          },
          question: {
            type: 'string',
            default: ''
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message for the submission. For the correct answer this is the success message.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check a single box for the correct answer.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems'],
        title: 'MultipleChoiceSingleAnswer'
      }]
    },
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    }
  },
  required: ['assignment', 'blueprintFileName', 'chapter_id', 'cloudProvider', 'course_id', 'fallbackAsset', 'hint', 'instructionSteps', 'question', 'title', 'xp'],
  definitions: {}
};
export const isValidCloudExerciseV1 = createValidator(CloudExerciseV1Schema);
export const CloudExerciseV1Definition = {
  schema: CloudExerciseV1Schema,
  validate: isValidCloudExerciseV1
};